

const service = {
    logo: 'logo.png',
    icons: 'https://tech2us.ma/content/icons/',
    domain: 'tech2us.ma',
    name: 'Tech2us',
    id: 2
}

const plan = {
    icon:'sync-1.png',
    link:'/order'
}

const contact = {
    address: "Ma Chae Allah, Al Wifaq, Temara 12000",
    email: "tech@2us.ma",
    phone: "+212 660 800 630",
    linkedin: "https://www.linkedin.com/company/tech2us",
    youtube: "https://www.youtube.com/@tech.2us",
    facebook: "https://www.facebook.com/tech2us.ma",
    theme: {
        red : {c:'rgb(102,0,0)', bc:'rgb(153,0,0)', bgc:'rgba(234,153,153,0.5)'},
        blue : {c:'rgb(7,55,99)', bc:'rgb(11,83,148)', bgc:'rgba(159,197,232,0.5)'},
        orange : {c:'rgb(120,63,4)', bc:'rgb(180,95,6)', bgc:'rgba(249,203,156,0.5)'},
        green : {c:'rgb(39,78,19)', bc:'rgb(56,118,29)', bgc:'rgba(182,215,168,0.5)'}
    }
}

const quote = {
    //logo:'https://digitalservices.ma/logo.png',
    background : 'https://tech2us.ma/images/Invoice-tech2us.jpg',
    logo:'https://tech2us.ma/images/logo.png',
    bc : ['#ccc', 'rgb(217,234,211)', 'rgb(208,224,227)', 'rgb(217,210,233)'],
    th : [{width:'55%',name:'Service'}, {width:'15%',name:'Quantity'}, {width:'15%',name:'Unit Price'}, {width:'15%',name:'Price'}],
}

const icons = {
    add : service.icons+'add.png',
    reload : service.icons+'reload.png',
    minimize : service.icons+'minimize.png',
    maximize : service.icons+'maximize.png'
}

const getApp = {
    image : 'https://tech2us.ma/images/SynchronizeApp-25.1.11.png',
    url : 'https://tech2us.ma/apps/SetupSynchronize-25.1.8.msi'
}

const bank = {
    Company: 'TECH2US',    
    RIB : '366 810 0117109 100050838 01',
    Name: 'BANK AL YOUSR',
}

export {service, plan, contact, quote, icons, getApp, bank}
